export default import.meta.ROLLDOWN_FILE_URL_1K0V031icE1orVqM8sp_9A